import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DatePicker, TimePicker, Input, Space } from "antd";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import moment from "moment";

import {
  calculateBusinessDays,
  debounce,
  disabledDate,
  disabledHours,
  disabledMinutes,
  formatDateTime,
  searchStringToObjMap,
  segmentedDays
} from "../../utils/CommonFunctions";

import styles from "../../styles/sass/search.module.scss";

const SelectDateTimeScreen = (props) => {
  const { resource_type } = props;
  const { query, asPath } = useRouter();

  const mWorkspace = useSelector(
    ({ workspace }) => workspace.workSpaceMap?.[query.spaceId]
  );

  const [slidepage, setSlidePage] = useState(false);

  useEffect(() => {
    setTimeout(() => setSlidePage(true), 500);
  });


  const [state, setState] = useState({
    from_date: null,
    to_date: null,
    from_time: null,
    duration: null,
    noof_days: null,
    to_month: null,
    durationType: null,
  });

  const {
    from_date,
    to_date,
    from_time,
    duration,
    to_month,
    noof_days,
    durationType,
    totalWorkingDays,
  } = state;

  const onNext = useCallback(
    (newState) => {
      const {
        from_date,
        to_date,
        from_time,
        duration,
        to_month,
        noof_days,
        durationType,
      } = newState;

      if (
        resource_type === "meeting_room" &&
        from_date &&
        from_time &&
        duration
      ) {
        const m_from_date = formatDateTime(from_date, "d");
        const m_from_time = formatDateTime(from_time, "t");

        console.log("m_from_date", m_from_date);
        console.log("m_from_time", m_from_time);

        props?.onNext?.(
          `${asPath}&from_date=${m_from_date}&from_time=${m_from_time}&duration=${duration}`
        );
      } else {
        if (durationType === "Days" && from_date && to_date) {
          const from_date_format = formatDateTime(from_date, "d");
          const to_date_format = formatDateTime(to_date, "d");

          props?.onNext?.(
            `${asPath}&from_date=${from_date_format}&to_date=${to_date_format}`
          );
        } else if (durationType === "Months" && from_date && to_month) {
          const from_date_format = formatDateTime(from_date, "d");
          const to_date_format = formatDateTime(
            moment(to_month).endOf("month"),
            "d"
          );
          props?.onNext?.(
            `${asPath}&from_date=${from_date_format}&to_date=${to_date_format}`
          );
        } else if (durationType === "Longer" && from_date && noof_days) {
          const from_date_format = formatDateTime(from_date, "d");
          const to_date_format = formatDateTime(
            moment(from_date).add(noof_days - 1, "days"),
            "d"
          );
          props?.onNext?.(
            `${asPath}&from_date=${from_date_format}&to_date=${to_date_format}`
          );
        }
      }
    },
    [props, resource_type, asPath]
  );

  const handleChange = useCallback(
    (name) => (event) => {
      const value = event?.target?.value ?? event;

      const newState = { [name]: value };

      if (durationType === "Months") {
        if (name === "from_date") {
          newState.totalWorkingDays = 0;
          newState.to_month = null;
        } else if (name === "to_month" && from_date) {
          const startDate = from_date;
          const endDate = moment(value).endOf("month");

          newState.totalWorkingDays = calculateBusinessDays(
            startDate,
            endDate,
            mWorkspace?.no_of_days
          );
        }
      }

      debounce(() => {
        setState((preState) => ({
          ...preState,
          ...newState,
        }));

        debounce(() => {
          onNext({
            ...state,
            ...newState,
          });
        }, 2000);
      }, 500);
    },
    [durationType, from_date, mWorkspace?.no_of_days, onNext, state]
  );

  const handleDurationType = useCallback(
    (item) => {
      console.log("item", item);
      if (
        (resource_type !== "meeting_room" && item !== "Hours") ||
        (resource_type === "meeting_room" && item === "Hours")
      ) {
        console.log("item", item);
        setState({
          durationType: item,
        });
      }
    },
    [resource_type]
  );

  const backgroudImageClass = useMemo(() => {
    let backgroudImageClass = "sdts_i";
    if (durationType && !from_date) {
      backgroudImageClass = "sdur_t_i";
    } else if (durationType && (from_date || to_date)) {
      backgroudImageClass = "sdts_d_i";
    }

    return backgroudImageClass;
  }, [durationType, from_date, to_date]);

  const diabledOptions = useCallback(
    (item) => {
      let disable;
      if (resource_type === "meeting_room" && item !== "Hours") {
        disable = true;
      } else if (resource_type !== "meeting_room" && item === "Hours") {
        disable = true;
      }
      return disable;
    },
    [resource_type]
  );

  const longerEndDate = useMemo(() => {
    if (from_date && noof_days) {
      return moment(from_date)
        .add(noof_days - 1, "days")
        .format("YYYY-MM-DD");
    }
  }, [from_date, noof_days]);

  return (
    <> 
              <div className={`${styles["bk_o_cb"]} ${styles[backgroudImageClass]}`}>
                <div
                  className={`${styles["bk_i_cb"]} ${
                    slidepage ? styles["bk_add_animation"] : ""
                  }`}
                >
                  <div className={`mc_container ${styles["bk_c_c_cb"]}`}>
                    <div
                      className={`${styles["bk_txt_cb"]} ${
                        durationType ? styles["pt10"] : ""
                      }`}
                    >
                      <h1 className={styles["title"]}>
                        How long would you like a space for?
                      </h1>
                    </div>
                    <div className={styles["bk_dt_og"]}>
                      <ul>
                        {segmentedDays.map((item) => (
                          <li key={item}>
                            <span
                              className={`${
                                durationType === item ? styles["active"] : "primary"
                              } ${diabledOptions(item) ? styles["disabled"] : ""}`}
                              onClick={() => handleDurationType(item)}
                            >
                              {item}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className={styles["bk_dt_cg"]}>
                      {durationType === "Hours" && resource_type === "meeting_room" && (
                        <div className={styles["dt_mr_og"]}>
                          <div className={styles["datarangecontainer"]}>
                            <p>Date</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              value={from_date}
                              onChange={handleChange("from_date")}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                              })}
                              allowClear={false}
                              defaultOpen={true}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>
                          <div
                            className={`${styles["datarangecontainer"]} ${
                              !from_date ? styles["disabled"] : ""
                            }`}
                          >
                            <p>Hours</p>
                            <Input
                              className={styles["ant-picker-input"]}
                              bordered={false}
                              type="number"
                              min={1}
                              step={0.5}
                              value={duration}
                              onChange={handleChange("duration")}
                              disabled={!from_date}
                            />
                          </div>
                          <div
                            className={`${styles["datarangecontainer"]} ${
                              !from_date || !duration ? styles["disabled"] : ""
                            }`}
                          >
                            <p>Select Time</p>
                            <TimePicker
                              popupClassName="custom-time-picker-container"
                              className={styles["data_c_c_b"]}
                              bordered={false}
                              size="large"
                              format="HH:mm"
                              value={from_time}
                              minuteStep={5}
                              onSelect={handleChange("from_time")}
                              disabledHours={() =>disabledHours(mWorkspace, from_date)}
                              disabledMinutes={() => disabledMinutes(from_date, from_time)}
                              showNow={false}
                              hideDisabledOptions={true}
                              allowClear={false}
                              disabled={!from_date || !duration}
                              inputReadOnly={true}
                            />
                          </div>
                        </div>
                      )}

                      {durationType === "Days" && (
                        <div className={styles["dt_mr_og"]}>
                          <div className={styles["datarangecontainer"]}>
                            <p>Start date</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              value={from_date}
                              onChange={handleChange("from_date")}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                              })}
                              allowClear={false}
                              defaultOpen={true}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>

                          <div
                            className={`${styles["datarangecontainer"]} ${
                              !from_date ? styles["disabled"] : ""
                            }`}
                          >
                            <p>End date</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              value={to_date}
                              onChange={handleChange("to_date")}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                                toDisabledDate: moment(from_date).subtract(1, "days"),
                              })}
                              allowClear={false}
                              defaultOpen={true}
                              disabled={!from_date}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>
                        </div>
                      )}

                      {durationType === "Months" && (
                        <div className={styles["dt_mr_og"]}>
                          <div className={styles["datarangecontainer"]}>
                            <p>Move-in date</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              value={from_date}
                              onChange={handleChange("from_date")}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                              })}
                              allowClear={false}
                              defaultOpen={true}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>

                          <div
                            className={`${styles["datarangecontainer"]} ${
                              !from_date ? styles["disabled"] : ""
                            }`}
                          >
                            <p>Select End Month</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              picker="month"
                              value={state?.to_month}
                              format={"MMM-YY"}
                              onChange={handleChange("to_month")}
                              disabled={!from_date}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                                toDisabledDate: from_date,
                              })}
                              allowClear={false}
                              defaultOpen={true}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>
                          {
                            <div className={styles["datarangecontainer"]}>
                              <p>Total Working Days</p>
                              <Input
                                bordered={false}
                                type="number"
                                min={1}
                                step={1}
                                value={totalWorkingDays}
                                disabled
                              />
                            </div>
                          }
                        </div>
                      )}

                      {durationType === "Longer" && (
                        <div className={styles["dt_mr_og"]}>
                          <div className={styles["datarangecontainer"]}>
                            <p>Date</p>
                            <DatePicker
                              className={styles["data_c_c_b"]}
                              dropdownClassName="custom-calender-conteiner"
                              bordered={false}
                              value={from_date}
                              onChange={handleChange("from_date")}
                              disabledDate={disabledDate({
                                activeDays: mWorkspace?.no_of_days,
                              })}
                              defaultOpen={true}
                              showToday={false}
                              inputReadOnly={true}
                            />
                          </div>

                          <div
                            className={`${styles["datarangecontainer"]} ${
                              !from_date ? styles["disabled"] : ""
                            }`}
                          >
                            <p>No of days</p>
                            <Input
                              bordered={false}
                              type="number"
                              value={noof_days}
                              min={1}
                              max={365}
                              onChange={handleChange("noof_days")}
                              disabled={!from_date}
                              autoFocus={true}
                            />
                          </div>

                          <div
                            className={`${styles["datarangecontainer"]} ${styles["disabled"]}`}
                          >
                            <p>End date</p>
                            <Input
                              className={styles["xl"]}
                              bordered={false}
                              value={
                                from_date &&
                                noof_days &&
                                moment(from_date)
                                  .add(noof_days - 1, "days")
                                  .format("YYYY-MM-DD")
                              }
                              disabled
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <span className="backPage" onClick={props?.onBack}> Back </span>
    </>
  );
};

export default SelectDateTimeScreen;
